import { render, staticRenderFns } from "./ListConvenio.vue?vue&type=template&id=06c458f2&scoped=true"
import script from "./ListConvenio.vue?vue&type=script&lang=js"
export * from "./ListConvenio.vue?vue&type=script&lang=js"
import style0 from "./ListConvenio.vue?vue&type=style&index=0&id=06c458f2&prod&lang=scss"
import style1 from "./ListConvenio.vue?vue&type=style&index=1&id=06c458f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c458f2",
  null
  
)

export default component.exports